export const saveData = (oar_low,oar_high,age_low,age_high,pref_age,income,education,pref_fans) => {
    return {
        type: 'CHANGE_ADHOC_BASE_DATA',
        data:{
          oar_low: oar_low,
          oar_high: oar_high,
          age_low: age_low,
          age_high: age_high,
          pref_age: pref_age,
          income: income,
          education: education,
          pref_fans: pref_fans,
        },
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Question5/actions.js